export default function LocationLink({ className, location, style, text }) {
  if (!location) return null

  let url = ""
  let linkText = ""
  className = className || "c-tint1"

  switch (location.locationType) {
    case "coords":
      if ((!location.latitude || !location.longitude) && !text) return null
      url = encodedAddressUrl(`${location.latitude}, ${location.longitude}`)
      linkText = text || `${location.latitude}, ${location.longitude}`
      break
    default:
      if (!location.fullFormattedAddress && !text) return null
      url = encodedAddressUrl(location.formattedAddress)
      linkText = text || location.fullFormattedAddress
      break
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    >
      {linkText}
    </a>
  )
}

const encodedAddressUrl = (address) => {
  const encodedAddress = encodeURIComponent(address).replace(/%20/g, "+")
  return `http://maps.google.com?q=${encodedAddress}`
}
